/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */
import React, { useEffect } from 'react';
import { Box } from '@mui/material';

import { IBiAnnualScheduleProps } from './CreateSchedule.Model';
import MonthDaySelector from './MonthDaySelector';

const BiAnnualSchedule: React.FC<IBiAnnualScheduleProps> = ({
  t,
  control,
  label,
  showLabel,
  selectFirstBiAnnualMonth,
  setSelectFirstBiAnnualMonth,
  selectSecondBiAnnualMonth,
  setSelectSecondBiAnnualMonth,
  selectFirstBiAnnualDay,
  setSelectFirstBiAnnualDay,
  selectSecondBiAnnualDay,
  setSelectSecondBiAnnualDay,
  isFirstMonthOpen,
  setIsFirstMonthOpen,
  isSecondMonthOpen,
  setIsSecondMonthOpen,
  setBiAnnualPayload,
}) => {
  useEffect(() => {
    if (selectFirstBiAnnualMonth && selectFirstBiAnnualDay && selectSecondBiAnnualMonth && selectSecondBiAnnualDay) {
      const biAnnualPayload = `M${selectFirstBiAnnualMonth}-${selectFirstBiAnnualDay}, M${selectSecondBiAnnualMonth}-${selectSecondBiAnnualDay}`;
      setBiAnnualPayload?.(biAnnualPayload);
    }
  }, [selectFirstBiAnnualMonth, selectFirstBiAnnualDay, selectSecondBiAnnualMonth, selectSecondBiAnnualDay]);

  return (
    <>
      {showLabel && label}
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <MonthDaySelector
          t={t}
          control={control}
          monthValue={selectFirstBiAnnualMonth}
          setMonthValue={setSelectFirstBiAnnualMonth}
          dayName="firstDay"
          setDayValue={setSelectFirstBiAnnualDay}
          isMonthOpen={isFirstMonthOpen}
          setIsMonthOpen={setIsFirstMonthOpen}
          showLabel={showLabel}
        />

        <MonthDaySelector
          t={t}
          control={control}
          monthValue={selectSecondBiAnnualMonth}
          setMonthValue={setSelectSecondBiAnnualMonth}
          dayName="secondDay"
          setDayValue={setSelectSecondBiAnnualDay}
          isMonthOpen={isSecondMonthOpen}
          setIsMonthOpen={setIsSecondMonthOpen}
          showLabel={showLabel}
        />
      </Box>
    </>
  );
};

export default BiAnnualSchedule;
